import { Form, Select, Typography } from "antd";
import "./index.css";
export const MySelect = ({
  withoutForm,
  name,
  label,
  mode,
  disabled,
  required,
  message,
  value,
  options,
  placeholder,
  className,
  ...props
}) => {
  return withoutForm ? (
    <Select
      maxTagCount="responsive"
      className="select"
      value={value}
      mode={mode || ""}
      disabled={disabled || false}
      placeholder={placeholder}
      {...props}
    >
      {options?.map((opt) => (
        <Select.Option value={opt?.id} key={opt?.id}>
          {opt?.name}
        </Select.Option>
      ))}
    </Select>
  ) : (
    <Form.Item
      name={name}
      label={<Typography.Text strong>{label}</Typography.Text>}
      rules={[
        {
          required,
          message,
        },
      ]}
      className={`customselect w-100 ${className}`}
    >
      <Select
        value={value}
        mode={mode || ""}
        disabled={disabled || false}
        maxTagCount="responsive"
        placeholder={placeholder}
        {...props}
      >
        {options?.map((opt) => (
          <Select.Option value={opt?.id} key={opt?.id}>
            {opt?.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
